<template>
  <HeaderTitle :title="title" />
  <HeaderActions
    :items="[
      // {
      //   title: 'Abbrechen',
      //   type: 'link',
      // },
    ]"
  >
  </HeaderActions>
  <HeaderProgressBar>
    <ProgressBar :current-step-code="newStep" :steps="steps"></ProgressBar>
  </HeaderProgressBar>
  <div class="px-10 sm:px-20 lg:px-44 flex flex-col flex-1">
    <QuestionnaireSteps v-if="loaded && newStep" :step-code="newStep" :document-id="documentId"></QuestionnaireSteps>
    <div class="absolute -z-10 right-0 bottom-0 h-2/3">
      <LegalStandardBackground />
    </div>
  </div>
</template>

<script setup lang="ts">
import LegalStandardBackground from '../assets/legal-standard-background.svg?component'
import HeaderActions from '../components/HeaderActions.vue'
import HeaderTitle from '../components/HeaderTitle.vue'
import HeaderProgressBar from '@/questionnaire/components/HeaderProgressBar.vue'
import ProgressBar from '@/components/ProgressBar.vue'
import QuestionnaireSteps from '@/questionnaire/components/QuestionnaireSteps.vue'

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useQuestionnaireStore } from '../stores/questionnaire'
import { storeToRefs } from 'pinia'

const props = defineProps<{ documentId: string; stepCode?: string; documentType?: string }>()
const router = useRouter()
const legalDocumentTemplateStore = useQuestionnaireStore()

const store = useQuestionnaireStore()
const { loaded, steps } = storeToRefs(store)

store.fetchData(props.documentId)
const title = computed(() => legalDocumentTemplateStore?.document?.template_name || '')
const newStep = computed(() => {
  const localNewStep = props.stepCode || (loaded ? steps?.value[0]?.code : undefined)
  if (localNewStep && !isCurrentPage(localNewStep)) {
    updateRoute(localNewStep)
  }

  return localNewStep
})

const isCurrentPage = (path: string) => router.currentRoute.value.path.match(`${props.documentId}/${path}`)

const updateRoute = (code?: string) => {
  const localStepCode = code || newStep.value
  if (loaded && localStepCode && !isCurrentPage(localStepCode)) {
    router.replace({
      name: 'questionnaire',
      params: {
        documentId: props.documentId,
        stepCode: localStepCode,
      },
    })
  }
}
</script>

<style>
:root {
  --content-position: calc(100vh - 5rem);
}

.step-reverse-enter-active,
.step-reverse-leave-active {
  transition: 500ms;
}

.step-enter-active,
.step-leave-active {
  transition: 1s;
}

.step-reverse-enter-from {
  transform: translateY(-200%);
}

.step-reverse-enter-to {
  transform: translateY(0);
}

.step-reverse-leave-from {
  transform: translateY(calc(-100vh + 5rem));
}

.step-reverse-leave-to {
  transform: translateY(100vh);
}

.step-enter-from {
  transform: translateY(100vh);
}

.step-enter-to {
  transform: translateY(calc(-100vh + 5rem));
}

.step-leave-to {
  transform: translateY(-100vh);
}
</style>
